import React, { ReactNode, useEffect } from "react";
import { AuthContext } from "../context/authContext";
import { PROXY_MANAGED_AUTH } from "../utils/getStorageToken";

const TOKEN_STORAGE_KEY = "authStorage";

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    // Remove credentials left by an older deployment. Current versions never
    // write or read an OAuth token in browser storage.
    localStorage.removeItem(TOKEN_STORAGE_KEY);
  }, []);

  const value = React.useMemo(
    () => ({
      token: { access_token: PROXY_MANAGED_AUTH },
      updateToken: () => {},
    }),
    []
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
